/**
 * @license
 * Copyright 2022 Superflow.dev
 * SPDX-License-Identifier: MIT
 */

import {LitElement, html, css, PropertyValueMap} from 'lit';
import {customElement, query, property} from 'lit/decorators.js';
import Util from './util';
import {DataObject, createDataObject} from './dataObjects';

/*

Modes: multiselect, select
Flows: view,edit

*/

/**
 * SfIBricks element.
 * @fires renderComplete - When the list is populated
 * @fires valueChanged - When the value is changed
 * @property apiId - backend api id
 * @property label - input label
 * @property name - name of the input
 * @property mode - mode of operation
 * @property selectedId - id to preselect
 * @property selectedValue - callback function
 */
@customElement('sf-i-bricks')
export class SfIBricks extends LitElement {
  
  @property()
  namesjson: string = "[]";

  getNamesJson = () => {
    return JSON.parse(this.namesjson)
  }
  @property()
  idsjson: string = "[]";

  getIdsJson = () => {
    return JSON.parse(this.idsjson)
  }

  @property()
  prepopulateValJson: string = "[]";

  getPrepopulateJson = () => {
    return JSON.parse(this.prepopulateValJson)
  }

  selectionObjects: DataObject[] = []

  selectedObjects: DataObject[] = []

  @property()
  mode: string = "";

  @property()
  flow: string = "";

  @property()
  maxselect: string = "0";

  static override styles = css`

    
    .SfIBricksC {
    }

    .invisible {
      visibility: hidden;
    }

    .m-0 {
      margin: 0px;
    }

    .m-20 {
      margin: 20px;
    }
    .md-20-ml-10 {
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .flex-grow {
      flex-grow: 1;
    }

    .left-sticky {
      left: 0px;
      position: sticky;
    }

    .color-lt-gray {
      color: #999;
      font-size: 95%;
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }

    .cursor {
      cursor: pointer;
    }

    .gone {
      display: none
    }

    .loader-element {
      position: fixed;
      right: 10px;
      top: 10px;
      margin-left: 5px;
    }

    .td-head {
      text-transform: capitalize;
    }

    .td-body {
      
    }

    .td-dark {
      background-color: #e9e9e9;
    }

    .td-highlight {
      background-color: black;
      color: white;
    }

    .td-light {
      background-color: #f6f6f6;
    }

    td {
      white-space: nowrap;
    }

    .align-start {
      align-items: flex-start;
    }

    .align-end {
      align-items: flex-end;
    }

    .align-center {
      align-items: center;
    }
    .align-stretch {
      align-items: stretch;
    }
    .p-10{
      padding: 10px
    }
    
    .lds-dual-ring {
      display: inline-block;
      width: 50px;
      height: 50px;
    }
    .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 50px;
      height: 50px;
      margin: 0px;
      border-radius: 50%;
      border: 2px solid #fff;
      border-color: #888 #ddd #888 #ddd;
      background-color: white;
      animation: lds-dual-ring 0.8s linear infinite;
    }

    .lds-dual-ring-lg {
      display: inline-block;
      width: 30px;
      height: 30px;
    }
    .lds-dual-ring-lg:after {
      content: " ";
      display: block;
      width: 30px;
      height: 30px;
      margin: 0px;
      border-radius: 50%;
      border: 3px solid #fff;
      border-color: #888 #ddd #888 #ddd;
      animation: lds-dual-ring 0.8s linear infinite;
    }

    .div-row-error {
      display: flex;
      justify-content: center;
      position: fixed;
      position: fixed;
      top: 0px;
      right: 0px;
      margin-top: 20px;
      margin-right: 20px;
      display: none;
      align-items:center;
      background-color: white;
      border: dashed 1px red;
      padding: 20px;
    }

    .div-row-error-message {
      color: red;
      padding: 5px;
      background-color: white;
      text-align: center;
    }

    .div-row-success {
      display: flex;
      justify-content: center;
      position: fixed;
      top: 0px;
      right: 0px;
      margin-top: 20px;
      margin-right: 20px;
      display: none;
      align-items:center;
      background-color: white;
      border: dashed 1px green;
      padding: 20px;
    }

    .div-row-success-message {
      color: green;
      padding: 5px;
      background-color: white;
      text-align: center;
    }

    .d-flex {
      display: flex;
    }

    .flex-col {
      flex-direction: column;
    }

    .flex-wrap {
      flex-wrap: wrap;
    }

    .justify-center {
      justify-content: center;
    }

    .justify-between {
      justify-content: space-between;
    }

    .justify-end {
      justify-content: flex-end;
    }

    .w-100-m-0 {
      width: 100%;
    }
    
    .mb-20 {
      margin-bottom: 20px;
    }
    
    .mt-20 {
      margin-top: 20px;
    }
    .mr-10 {
      margin-right: 10px;
    }
    .mr-5 {
      margin-right: 5px;
    }
    
    .p-7 {
      padding: 7px
    }

    @keyframes lds-dual-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }  

    .hide {
      display: none;
    }

    .lb {
      width: 5%
    }
    .rb {
      width: 5%
    }

    @media (orientation: landscape) {

      .lb {
        width: 30%
      }
      .rb {
        width: 30%
      }

    }
    
    .progress-bar-complete {
      height: 20px;
      background-color: #123;
    }
    .progress-bar-incomplete {
      height: 20px;
      background-color: #555
    }

    .button-icon {
      pointer-events: none
    }
    
    .selected-option {
      font-size: 70%;
      padding: 5px;
      border-radius: 10px;
      border: solid 1px #dddddd;
      white-space: nowrap;
      overflow: hidden !important;
      min-width: 50px;
    }
  `;

  @query('.SfIBricksC')
  _SfIBricksC: any;

  @query('#outer-container')
  _SfOuterContainer: any;

  @query('#selection-container')
  _SfSelectionContainer: any;
  
  @query('#selected-container')
  _SfSelectedContainer: any;

  constructor() {
    super();
  }
  selectedValues = () => {
    let retArr = []
    for(let selectedObj of this.selectedObjects){
      retArr.push(selectedObj.id)
    }
    return retArr
  }

  selectedTexts = () => {
    let retArr = []
    for(let selectedObj of this.selectedObjects){
      retArr.push(selectedObj.name)
    }
    return retArr
  }

  selectedValueTexts = () => {
    let retArr = []
    for(let selectedObj of this.selectedObjects){
      retArr.push(selectedObj.name + ';' + selectedObj.id)
    }
    return retArr
  }

  populateSelection = () => {
    let sortedNamesArr = Util.alphabeticalSort(this.getNamesJson());
    this.selectionObjects = []
    
    for(let tempName of sortedNamesArr){
      this.selectionObjects.push(createDataObject({name:tempName,id: (this.getIdsJson()[this.getNamesJson().indexOf(tempName)])}))
    }
  }
  populateSelected = () => {
    
    let sortedNamesArr = [];
    for(let tempVal of this.getPrepopulateJson()){
      if(this.getIdsJson()[this.getNamesJson().indexOf(tempVal.split(';')[0])] == tempVal.split(';')[1]){
        sortedNamesArr.push(tempVal.split(';')[0])
      }
    }
    sortedNamesArr = Util.alphabeticalSort(sortedNamesArr);
    this.selectedObjects = []
    for(let tempName of sortedNamesArr){
      this.selectedObjects.push(createDataObject({name:tempName,id: this.getIdsJson()[this.getNamesJson().indexOf(tempName)]}))
    }
  }
  populateSingleSelectView = () => {
    let html = ''
    if(this.selectedObjects.length == 0){
      console.log(this.selectedObjects.length);
      html += `<select id="input-select-single" part="input-select-single">`
      html += `<option value="default" part="input-select-single-option">Select</option>`
      for(let selectObj of this.selectionObjects){
        let foundflag = false
        for(let selectedObj of this.selectedObjects){
          if(selectObj.id == selectedObj.id){
            foundflag = true
            continue;
          }
        }
        if(foundflag){
          continue;
        }
        html += `<option value="${selectObj.id}" part="input-select-single-option">${selectObj.name.replace(/ *\([^)]*\) */g, "").trim()}</option>`
      }
      html += `</select>`;
    }
    (this._SfSelectionContainer as HTMLDivElement).innerHTML = html
    let selectElement = (this._SfSelectionContainer as HTMLDivElement).querySelector('#input-select-single') as HTMLSelectElement
    selectElement?.addEventListener('change', (e:any) => {
      let target = e.target
      console.log('target.value', target.value)
      if(target.value == null || target.value == "" || target.value == "default"){
        return;
      }
      let selectedId = target.value
      this.selectedObjects = []
      this.selectedObjects.push(createDataObject({name: this.getNamesJson()[this.getIdsJson().indexOf(selectedId)], id:selectedId}))
      this.populateSingleSelectView()
      let event = new CustomEvent('valueChanged')
      this.dispatchEvent(event);
    })
    setTimeout(() => {
      this.populateSelectedView();
    },500)
  }
  populateMultiSelectView = () => {
    let html = ''
    let flagAddSelectAll = false
    for(let [i, selectObj] of this.selectionObjects.entries()){
      if(parseInt(this.maxselect) > 0 && parseInt(this.maxselect) <= this.selectedObjects.length){
        continue;
      }
      let foundflag = false
      for(let selectedObj of this.selectedObjects){
        if(selectObj.id == selectedObj.id){
          foundflag = true
          continue;
        }
      }
      if(foundflag){
        continue;
      }
      html += `
        <div class="d-flex justify-start align-center select-option" part="input-select-multi-option" id="select-option-${i}">
          <input type="checkbox" id="select-option-checkbox-${i}" class="select-option-checkbox mr-5">
          <label for="select-option-checkbox-${i}" part="select-option-label" id="select-label-${i}">${selectObj.name.replace(/ *\([^)]*\) */g, "").trim()}</label>
        </div>
      `
      flagAddSelectAll = true;
    }
    if(flagAddSelectAll){
      html += `
        <div class="d-flex justify-start align-center select-option" part="input-select-multi-option" id="select-option-all">
          <input type="checkbox" id="select-option-checkbox-all" class="select-option-checkbox mr-5">
          <label for="select-option-checkbox-all" part="select-option-label" id="select-label-all">Select All</label>
        </div>
      `
    }
    (this._SfSelectionContainer as HTMLDivElement).innerHTML = html
    let selectOptions = (this._SfSelectionContainer as HTMLDivElement).querySelectorAll('.select-option') as NodeListOf<HTMLDivElement>
    for(let selectOption of selectOptions){
      selectOption.addEventListener('click',async (e:any)=>{
        let target = e.target
        let index = target.id.split('-')[2]
        if(index == "checkbox") index = target.id.split('-')[3]
        let checkbox = (this._SfSelectionContainer as HTMLDivElement).querySelector('#select-option-checkbox-' + index) as HTMLInputElement
        if(checkbox != null)checkbox.checked = true;
        let tempSortedNames: string[] = []
        let tempSelected: any[] = []
        if(index == "all"){
          let tempNames = []
          let tempIds = []
          for(let selectObj of this.selectionObjects){
            tempNames.push(selectObj.name)
            tempIds.push(selectObj.id)
          }
          tempSortedNames = Util.alphabeticalSort(JSON.parse(JSON.stringify(tempNames)))
          tempSelected = []
          for(let tempName of tempSortedNames){
            tempSelected.push(createDataObject({name: tempName, id: tempIds[tempNames.indexOf(tempName)]}))
          }
        }else{
          let selectedObj = this.selectionObjects[index]
          let tempNames = []
          let tempIds = []
          for(let tempObj of this.selectedObjects){
            tempNames.push(tempObj.name)
            tempIds.push(tempObj.id)
          }
          tempNames.push(selectedObj.name)
          tempIds.push(selectedObj.id)
          tempSortedNames = Util.alphabeticalSort(JSON.parse(JSON.stringify(tempNames)))
          tempSelected = []
          for(let tempName of tempSortedNames){
            tempSelected.push(createDataObject({name: tempName, id: tempIds[tempNames.indexOf(tempName)]}))
          }
        }
        this.selectedObjects = tempSelected
        this.populateMultiSelectView()
        let event = new CustomEvent('valueChanged')
        this.dispatchEvent(event);
      })
    }
    setTimeout(() => {
      this.populateSelectedView();
    },500)
  }
  populateSelectedView = () => {
    let html = ''
    for(let [i, selectedObj] of this.selectedObjects.entries()){
      html += `
        <div class="selected-option d-flex justtify-center align-center" part="selected-option" id="selected-option-${i}">
          ${this.flow == "view" ? '' : '<span class="material-icons selected-option-icon mr-5">cancel</span>'}
          <label part="selected-option-label">${selectedObj.name.replace(/ *\([^)]*\) */g, "").trim()}</label>
        </div>
      `
    }
    (this._SfSelectedContainer as HTMLDivElement).innerHTML = html;
    (this._SfSelectedContainer as HTMLDivElement).style.display = this.selectedObjects.length > 0 ? 'flex' : 'none'
    if(this.flow !== "view"){
      (this._SfSelectionContainer as HTMLDivElement).style.display = 'flex'
      let selectedOptions = (this._SfSelectedContainer as HTMLDivElement).querySelectorAll('.selected-option') as NodeListOf<HTMLDivElement>
      for(let selectedOption of selectedOptions){
        selectedOption.addEventListener('click', (e:any) => {
          let target = e.target
          let index = parseInt(target.id.split('-')[2])
          this.selectedObjects.splice(index,1)
          this.populateSelectedView()
          setTimeout(() => {
            if(this.mode == "select"){
              this.populateSingleSelectView();
            }else if(this.mode == "multiselect"){
              this.populateMultiSelectView();
            }
          },500)
          let event = new CustomEvent('valueChanged')
          this.dispatchEvent(event);
        })
      }
    }else{
      (this._SfSelectionContainer as HTMLDivElement).style.display = 'none'
    }
  }
  loadMode = async () => {
    console.log('loadmode', this.mode, this.flow);
    this.populateSelection();
    this.populateSelected()
    this.populateSelectedView()
    if(this.flow != "view"){
      if(this.mode == "select"){
        this.populateSingleSelectView();
      }else if(this.mode == "multiselect"){
        this.populateMultiSelectView()
      }
    }
  }

  protected override firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {

    this.loadMode();

  }
  
  override connectedCallback() {
    super.connectedCallback()
  }
  
  override render() {
    return html`
      <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
      <div part="outer-container" class="SfIBricksC d-flex flex-col align-center" part="outer-container">
        <div id="selected-container" part="selected-container" class="w-100-m-0 d-flex flex-wrap justify-start align-start hide"></div>
        <div id="selection-container" part="selection-container" class="w-100-m-0 d-flex flex-wrap justify-start align-start"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sf-i-bricks': SfIBricks;
  }
}
